import React, { memo } from 'react';
import { CompanyLocationMap, NoData } from '@components';
import { yellowAnchor, blueAnchor, redAnchor } from '@model';
import { useSelector } from 'react-redux';

// import '@style/modules/analysis/analysisRight.scss';
import '../../../../styles/modules/analysis/analysisRight.scss';

function Headquarters({ data, resourceId, isSingleCompany }) {
  const { he } = data;
  he.forEach((a) => {
    a.locations = [a.location];
    // delete a.location;
  });
  const { buyerLabel, targetLabel } = useSelector(({ common }) => ({
    buyerLabel: common.projectCompanyInfo.buyerLabel,
    targetLabel: common.projectCompanyInfo.targetLabel,
  }));

  return (
    <div className="analysis-right-wrapper headquarter">
      <div className="title">Headquarters</div>
      {he.every((obj) => obj.isManualInput) ? (
        <NoData />
      ) : (
        <div className="bottom">
          <ul className="company-info">
            <li>
              <div>
                {buyerLabel}
                <img src={yellowAnchor} alt="buyer" />
              </div>
              <div>{he[0].companyName || '-'}</div>
            </li>
            {he[1]?.companyName && (
              <li>
                <div>
                  {targetLabel}
                  <img src={blueAnchor} alt="target" />
                </div>
                <div>{he[1].companyName || '-'}</div>
              </li>
            )}
          </ul>
          <CompanyLocationMap locationsInfo={he} />
          <div className="map-legend">
            {isSingleCompany ? (
              <>
                <img src={yellowAnchor} alt="buyer" />
                {buyerLabel}
              </>
            ) : (
              <>
                <img src={yellowAnchor} alt="buyer" />
                {buyerLabel}
                <img src={blueAnchor} alt="target" />
                {targetLabel}
                <img src={redAnchor} alt="mixure" />
                {buyerLabel}&{targetLabel}
              </>
            )}
          </div>
        </div>
      )}
    </div>
  );
}

export default memo(Headquarters);
